"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduledActivityTypes = void 0;
var scheduledActivityTypes;
(function (scheduledActivityTypes) {
    scheduledActivityTypes["SEND_KIT"] = "sendKit";
    scheduledActivityTypes["SCHEDULE_CALL"] = "scheduleCall";
    scheduledActivityTypes["GENERIC"] = "generic";
    scheduledActivityTypes["SEND_EMAIL"] = "sendEmail";
    scheduledActivityTypes["SEND_SMS"] = "sendSms";
    scheduledActivityTypes["SEND_LETTER"] = "sendLetter";
    scheduledActivityTypes["SEND_PRIORITIZED_OUTREACH"] = "sendPrioritizedOutreach";
    scheduledActivityTypes["SEND_PUSH_NOTIFICATION"] = "sendPushNotification";
})(scheduledActivityTypes || (exports.scheduledActivityTypes = scheduledActivityTypes = {}));
